import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    quickbooksFeatureKey,
    QuickbooksOnlineState
} from './quickbooks.reducer';

export const selectQuickbooksOnlineState =
    createFeatureSelector<QuickbooksOnlineState>(quickbooksFeatureKey);

export const getHasValidTokens = createSelector(
    selectQuickbooksOnlineState,
    state => state.HasValidTokens
);

export const getAuthUrl = createSelector(
    selectQuickbooksOnlineState,
    state => state.AuthUrl
);
export const getEmployeesWithHours = createSelector(
    selectQuickbooksOnlineState,
    state => state.EmployeesWithHours
);
export const getContractorsWithHours = createSelector(
    selectQuickbooksOnlineState,
    state => state.ContractorsWithHours
);
export const getEmployeesWithPurchases = createSelector(
    selectQuickbooksOnlineState,
    state => state.EmployeesWithPurchases
);
export const getMinApprovedTimeNotSent = createSelector(
    selectQuickbooksOnlineState,
    state => state.MinApprovedTimeNotSent
);
export const getMaxApprovedTimeNotSent = createSelector(
    selectQuickbooksOnlineState,
    state => state.MaxApprovedTimeNotSent
);
export const getSendHoursInProgress = createSelector(
    selectQuickbooksOnlineState,
    state => state.SendHoursInProgress
);
export const getSendHoursProgress = createSelector(
    selectQuickbooksOnlineState,
    state => state.SendHoursProgress
);
